import script from "./AnnouncementsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementsPage.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementsPage.vue?vue&type=style&index=0&id=5673e382&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5673e382"]])

export default __exports__